import { Injectable } from '@angular/core';
import { ApiUrlHelper } from 'app/_service/api-url-helper';
import { HttpClientHelper } from 'app/_service/http-helper';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class DiscoveryService {

  constructor(
    private _apiUrlHelper: ApiUrlHelper,
    private _httpClientHelper: HttpClientHelper,
  ) { }

  getHotAlbums(size, isfresh): Observable<any> {
    const apiURL = this._apiUrlHelper.urlBuilder(
      'get-hot-albums',
      {
        size: size,
        isfresh: isfresh,
      }
    );
    return this._httpClientHelper.get(apiURL).pipe(
      map(res => {
        // console.log(res);
        return res.length > 0 ? res : [];
      })
    );
  }

  getSubAlbumList(size): Observable<any> {
    const apiURL = this._apiUrlHelper.urlBuilder(
      'get-sub-album-list',
      {
        size: size,
      }
    );
    return this._httpClientHelper.get(apiURL).pipe(
      map(res => {
        return res;
      })
    );
  }

  getAlbumFlowList(page, size, label): Observable<any> {
    const apiURL = this._apiUrlHelper.urlBuilder(
      'get-album-flow-list',
      {
        page: page,
        size: size,
        label: label ? label : '',
      }
    );
    return this._httpClientHelper.get(apiURL).pipe(
      map(res => {
        return res;
      })
    );
  }

  getSubAlbumRndList(label): Observable<any> {
    const apiURL = this._apiUrlHelper.urlBuilder(
      'get-sub-album-rnd-list',
      {
        label: label,
        size: 16,
      }
    );
    return this._httpClientHelper.get(apiURL).pipe(
      map(res => {
        return res;
      })
    );
  }

  getHotUsers(size): Observable<any>  {
    const apiURL = this._apiUrlHelper.urlBuilder(
      'get-hot-users',
      {
        size: size,
      }
    );
    return this._httpClientHelper.get(apiURL).pipe(
      map(res => {
        return res;
      })
    );
  }

  getAlbumLabels(): Observable<any[]> {
    const apiURL = this._apiUrlHelper.urlBuilder('get-ablum-labels', {});
    return this._httpClientHelper.get(apiURL)
    .pipe(
        map(items => {
            return items.map((item, index) => {
                return {
                    title: item,
                    id: index,
                };
            });
        })
    );
  }

  getAlbumSubLabels(tag): Observable<any[]> {
    const apiURL = this._apiUrlHelper.urlBuilder(
      'get-album-sub-labels',
      {
        tag: tag,
      }
    );
    return this._httpClientHelper.get(apiURL)
    .pipe(
        map(res => {
          return res;
        })
    );
  }

  getDiscoveryListByLabel(params): Observable<any[]> {
    const apiURL = this._apiUrlHelper.urlBuilder(
      'get-album-list-by-label',
      {
        page: params.page,
        size: params.size,
        tag: params.tag,
        label: params.label,
        key: !!params.key ? params.key : '',
        region: !!params.region ? params.region : '',
      }
    );
    return this._httpClientHelper.get(apiURL)
    .pipe(
        map(res => {
          return res[0];
        })
    );
  }
}
